import useReconciliation from "@/hooks/useReconciliation";

import { ReconciliationProgress } from "./ReconciliationProgress";

export default function ReconciliationWorkingV2() {
  const { working, isBatchRunning } = useReconciliation();

  if (!working || isBatchRunning) return null;

  return (
    <div className="fixed inset-0 z-10000 flex items-center justify-center bg-[#0F172A]/80 backdrop-blur-md transition-all duration-300">
      <div className="relative w-full max-w-120 rounded-[40px] border border-white/5 bg-[#171821] p-6 shadow-[0_0_50px_0_rgba(0,0,0,0.5)]">
        <ReconciliationProgress
          title="Conciliación en proceso"
          description="Se está procesando tu conciliación. Por favor espera hasta que se finalice el proceso."
          isRunning
        />
      </div>
    </div>
  );
}
